module.exports = __webpack_public_path__ + "static/media/ser_dec_mar.89243170.png";